import React from 'react';
import T from 'prop-types';

export const UnderlineText = ({ text, className, onClick }) => {
    return <div className={className} onClick={onClick}>{text}</div>;
};

UnderlineText.T = {
    text: T.string,
    className: T.string,
    onClick: T.func
};

UnderlineText.defaultProps = {
    className: 'underlineDefault',
    onClick: undefined
};
